import { render, staticRenderFns } from "./NewRemoteDataTable.vue?vue&type=template&id=c5348730"
import script from "./NewRemoteDataTable.vue?vue&type=script&lang=ts"
export * from "./NewRemoteDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports